<template>
  <span>
    <v-flex d-flex v-for="(questionnaire, i) in questionnaires" :key="`questionnaire-${i}`">
      <v-card flat color="text-xs-justify" tile>
        <v-card-title>
          <div>
            <div class="subheading">{{ questionnaire.answerSet.phase }}</div>
            <div v-if="questionnaire.answerSet.submittedAt">
              <v-icon small class="text-vertical-middle">mdi-calendar</v-icon>
              {{ new Date(questionnaire.answerSet.submittedAt) | date('do MMM yyyy') }}
            </div>
            <div v-else class="warning--text text-xs-center">
              Answers have <strong>NOT</strong> been submitted
            </div>
          </div>
        </v-card-title>
        <v-divider />
        <div
          v-for="({ question, answer }, j) in sortQuestions(questionnaire.questions)"
          :key="`${i}-question-${question.position}`"
        >
          <v-card-title class="pb-1">
            <strong>{{ j + 1 }}. {{ question.title }}</strong>
          </v-card-title>
          <v-card-text
            class="pt-0 px-4"
            v-if="question.type === 'text' && answer && answer.content"
          >
            {{ answer.content }}
          </v-card-text>
          <v-card-text
            class="pt-0 px-4"
            v-else-if="question.type === 'file' && answer && answer.attachment"
          >
            <v-btn target="_blank" :href="answer.attachment.url" block color="secondary">
              View
              <v-icon right>mdi-cloud-download</v-icon>
            </v-btn>
            <can I="edit" a="Answer">
              <DocumentUpload
                button
                label="Replace"
                :action="`/admin/answers/${answer.id}/file`"
                :value="answer.attachment"
                auto-submit
                @submit="$emit('updated')"
              />
            </can>
          </v-card-text>
          <v-card-text
            class="pt-0 px-4"
            v-else-if="question.type === 'choice' && answer && answer.content"
          >
            {{ answer.content }}
          </v-card-text>
          <v-card-text class="pt-0 px-4" v-else>
            <v-icon v-if="!question.optional">mdi-alert</v-icon>
            <em>No answer was submitted.</em>
          </v-card-text>
        </div>
        <can I="edit" a="AnswerSet">
          <div v-if="questionnaire.answerSet.submittedAt">
            <v-menu top right max-width="300" v-model="unsubmitting">
              <v-btn slot="activator" flat color="grey">
                <v-icon left>mdi-undo</v-icon>
                Unsubmit
              </v-btn>
              <v-card>
                <v-card-text>
                  You are about to <strong>UNSUBMIT</strong> the candidate's
                  <strong>{{ questionnaire.answerSet.phase }}</strong> prescreening qeustions.
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn flat color="grey" @click="unsubmitting = false">Cancel</v-btn>
                  <v-btn @click="unsubmit(questionnaire.answerSet)" color="primary">Unsubmit</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </div>
        </can>
      </v-card>
    </v-flex>
  </span>
</template>

<script>
// Components
import DocumentUpload from '@/components/DocumentUpload'
import { byPosition, bySubmittedAt } from '@/sorting/QuestionnaireQuestions'

export default {
  props: { value: [Object, Array] },
  components: { DocumentUpload },
  data() {
    return {
      unsubmitting: false,
    }
  },
  computed: {
    questionnaires() {
      return JSON.parse(JSON.stringify(this.value)).sort(bySubmittedAt({ asc: false }))
    },
  },
  methods: {
    sortQuestions(questions) {
      return questions
      if (questions && questions[0]) {
        return questions.sort(byPosition())
      }
      return []
    },
    unsubmit(answerSet) {
      if (!this.$can('edit', 'AnswerSet')) return

      this.$http
        .patch(
          `admin/answer_sets/${answerSet.id}`,
          Object.assign(answerSet, { submitted_at: null })
        )
        .then(
          response => {
            console.log({ response })
            this.$store.dispatch('snackbarSuccess', 'Unsubmitted')
            this.$emit('updated')
          },
          errors => {
            console.log({ errors })
            this.$store.dispatch('snackbarError', 'Could not unsubmit answers')
          }
        )
    },
  },
}
</script>
